import { useState } from "react";
import toast from "react-hot-toast";
import { Button, Modal, Textarea } from "flowbite-react";
import { updateMessage } from "../../../api/conversations";

const EditModal = ({ openModal, setOpenModal, text, conversationId, messageId, fetchInfluencer }) => {
  const [message, setMessage] = useState(text);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      await updateMessage({
        id: conversationId,
        data: {
          message,
          id: messageId,
        }
      });
      
      await fetchInfluencer();

      setOpenModal(false);

      toast.success('Message has been updated successfully');
    } catch (error) {
      console.error(error);
      toast.error('Failed to update the message');
    } finally {
      setLoading(false);
    }
  }

  return (
    <Modal show={openModal} onClose={() => setOpenModal(false)} popup>
      <Modal.Header />
      <Modal.Body>
        <form onSubmit={handleSubmit} className="space-y-6">
          <h3 className="text-xl font-medium text-gray-900">Edit message</h3>
          <div>
            <Textarea
              id="message"
              name="message"
              value={message}
              onChange={e => setMessage(e.target.value)}
              required
              rows={16}
            />
          </div>
          <div className="w-full">
            <Button
              type="submit"
              isProcessing={loading}
              disabled={loading}
            >
              Update
            </Button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
}

export default EditModal;